import * as React from "react";
export var colorStatus = function colorStatus(polizaRenewalStatus) {
  switch (polizaRenewalStatus) {
    case "pending":
    case "Pendiente":
    case "Pendiente de condiciones":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE1 ");
    // 🟡 Amarillo (pendiente)

    case "in_progress":
    case "En progreso":
    case "Consultando cliente/compañía":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE3 ");
    // 🟢 Verde (en progreso)

    case "with_conditions":
    case "Con condiciones":
    case "Condición cargada":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE2 ");
    // 🔵 Azul (con condiciones)

    case "renewed":
    case "Renovada":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE2 ");
    // 🔵 Azul (renovada)

    case "not_renewed":
    case "No renovada":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDD34 ");
    // 🔴 Rojo (no renovada)

    default:
      return null;
  }
};
export var colorCondition = function colorCondition(condition) {
  if (!condition || condition === "" || condition === null || condition === undefined) {
    return null;
  }

  switch (condition) {
    case "same_conditions":
    case "Iguales condiciones":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE2 ");
    // 🔵 Azul (positivo)

    case "change_conditions":
    case "Cambio condiciones":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE3 ");
    // 🟢 Verde (cambio)

    case "without_conditions":
    case "Sin condiciones":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE1 ");
    // 🟡 Amarillo (pendiente)

    case "extension":
    case "Prorroga":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDFE2 ");
    // 🔵 Azul (positivo)

    case "client_rejects_renewal":
    case "No renueva cliente":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDD34 ");
    // 🔴 Rojo (negativo)

    case "company_rejects_renewal":
    case "No renueva Compañía":
      return /*#__PURE__*/React.createElement("span", null, "\uD83D\uDD34 ");
    // 🔴 Rojo (negativo)

    default:
      return null;
  }
};